import { Component, Input, Output, EventEmitter, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { CampaignStep } from '../campaign-step';
import { Campaign } from '../campaign';
import { CampaignService } from '../../../../services/campaign/campaign.service';

@Component({
  selector: 'campaign-step-5',
  templateUrl: 'campaign-step-5.html',
  styles: [
    '::ng-deep th, ::ng-deep td, ::ng-deep td label {overflow-wrap: break-word !important;}',
    '.not-editable {overflow: hidden; white-space: nowrap; text-overflow: ellipsis;}',
    '::ng-deep td input, ::ng-deep td label {max-width: 100% !important}',
    '::ng-deep body .ui-radiobutton-icon {width: 90% !important; line-height: 12px !important; margin: 1px auto !important;}',
    '.add-coupon-btn.Coupon-preview {width: 250px; margin-top: 5px !important; height: 36px; font-size: 16px; }',
    '.add-coupon-btn.Coupon-preview:hover {border: 1px solid #20417b !important; color: #20417b !important; background-color: #fff !important;}',
    '.add-coupon-btn.Coupon-preview:not(:disabled):hover {cursor: pointer; color: #fff !important; background-color: #20417b !important;}',
    '.add-coupon-btn.Coupon-preview:disabled {opacity: .5}',
    '::ng-deep p-calendar .ui-calendar {max-width: 100% !important;}',
    '::ng-deep p-calendar .ui-datepicker-group {width: 300px !important;}'
  ]
})
export class CampaignStep5Component implements CampaignStep {
  @Input() campaign: Campaign;
  @Input() savedPriorities: any[];  // priorità selezionate nello step precedente
  @Input() savedCategories: any[]; // categorie coupon selezionate nello step precedente
  @Input() savedProductCouponsF: any[]; // coupon prodotti finanziati selezionati nello step precedente
  @Input() savedProductCouponsNF: any[]; // coupon prodotti non finanziati selezionati nello step precedente

  @Output() returnedSavedCategories: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsF: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsNF: EventEmitter<any[]> = new EventEmitter();
  @Output() availableTargeting: EventEmitter<boolean> = new EventEmitter();

  @ViewChildren('couponTables') couponTables: QueryList<any>;

  categories: Array <{label: string, value: string}> = [];
  segmentOptions: Array <{label: string, value: string}> = [];
  discountTypes: Array <{label: string, value: string}> = [];
  campaignName: string;
  editingMode = false;
  channels: Array <{name: string, value: string}>;
  channelsOptions: Array <{label: string, value: string}> = [];
  showShortDescDialog = false;
  showCompleteDescDialog = false;
  generatedCoupons: any = {};

  constructor(private campaignService: CampaignService, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit()
  {
    this.getCouponData();
    this.campaignService.getAvailableTargeting(encodeURIComponent(this.campaign.name)).subscribe(res => {
      let targetingAvailable = res == 'OK' ? true : false;
      this.availableTargeting.emit(targetingAvailable);
    });
  }

  public isStepCompleted()
  {
    return true;
  }

  /**
   * Richiama la lista dei coupon generati
  */
  getCouponData() {
    this.campaignName = encodeURIComponent(this.campaign.name);
    this.campaignService.getChannels().subscribe(res => {this.channels = res});

    Object.assign(this.generatedCoupons, {coupons: []});
    this.campaignService.getActiveCoupons(this.campaignName).subscribe(
      activeCoupons => {
        activeCoupons.map(
          activeCoupon => {
            if (activeCoupon.flag_tipo_attivo) {
              this.generatedCoupons.coupons.push(activeCoupon);
            }
          }
        );
        this.generatedCoupons.coupons.map(
          coupon => {
            let couponList: any[] = []
            if (coupon.codice_tipo === 1) {
              Object.assign(coupon, {name: 'Trade Driver'});
            } else if (coupon.codice_tipo === 2) {
              Object.assign(coupon, {name: 'Categoria'});
            } else if (coupon.codice_tipo === 3 ) {
              Object.assign(coupon, {name: 'Prodotto (finanziato)'});
            } else {
              Object.assign(coupon, {name: 'Prodotto (NON finanziato)'});
            }
            this.campaignService.getCouponList(this.campaignName, coupon.codice_tipo.toString()).subscribe(
              res => this.manageCouponData(res, couponList),
              error => console.error(error),
              () => {
                Object.assign(coupon, {couponList: couponList});
              }
            )
          }
        );
      }
    )

  }

  /**
   * Gestisce i dati dei coupon prima di aggiungerli alla lista
  */
  manageCouponData(data, couponList) {
    data.map(d => {
      if (d.clienti) {
        d.clienti = d.clienti.split("-");
      }
      if (d.data_inizio_validita) {
        d.data_inizio_validita = d.data_inizio_validita.substring(8, 10) + '/' + d.data_inizio_validita.substring(5, 7) + '/' + d.data_inizio_validita.substring(0, 4);
      }
      if (d.data_fine_validita) {
        d.data_fine_validita = d.data_fine_validita.substring(8, 10) + '/' + d.data_fine_validita.substring(5, 7) + '/' + d.data_fine_validita.substring(0, 4);
      }
      if (d.data_inizio_emissione) {
        d.data_inizio_emissione = d.data_inizio_emissione.substring(8, 10) + '/' + d.data_inizio_emissione.substring(5, 7) + '/' + d.data_inizio_emissione.substring(0, 4);
      }
      if (d.data_fine_emissione) {
        d.data_fine_emissione = d.data_fine_emissione.substring(8, 10) + '/' + d.data_fine_emissione.substring(5, 7) + '/' + d.data_fine_emissione.substring(0, 4);
      }
      /* if (d.sconto) {
        d.sconto = d.sconto.replace(/[^0-9.]/g, "");
      }
      if (d.soglia) {
        d.soglia = d.soglia.replace(/[^0-9.]/g, "");
      } */
      couponList.push(d);
    })
  }

  /**
   * Porta all'ultima pagina della Tabella p-table
  */
  goToTableLastPage(i, newValues?) {
    let couponTablesList = this.couponTables.toArray();
    let couponTable = couponTablesList[i];

    if (newValues) {
      couponTable.value = newValues;
    }

    // number of pages in the table
    let pageCount = Math.ceil(couponTable.totalRecords / couponTable.rows);

    if (pageCount > 1) {
      // last page
      let lastPage = pageCount - 1;
      // porto la table all'ultima pagina
      couponTable.onPageChange({
        pageCount,
        lastPage,
        first: lastPage * couponTable.rows,
        rows: couponTable.rows
      });
    }
  }

  /**
   * Richiama dati per le select e i radio nel form di modifica del coupon
  */
  callCouponEditingData(typeCode) {
    // Richiama dati che vanno a popolare i radio nella colonna Tipo Sconto
    this.campaignService.getTipoSconto(this.campaignName, typeCode).subscribe(res => res.map(r => {
      this.discountTypes.push({
        label: r.descrizione_metodo,
        value: r.descrizione_metodo
      });
    }));
    // Richiama dati che vanno a popolare i radio nella colonna Categoria
    this.campaignService.getCategoriaOfferta(typeCode).subscribe(res => res.map(r => {
      this.categories.push({
        label: r.categoria_offerta,
        value: r.categoria_offerta
      });
    }));
    // Richiama dati che vanno a popolare la select nella colonna Clienti
    this.campaignService.getSegmentsOptions().subscribe(res => res.map(r => {
      this.segmentOptions.push({
        label: r.descrizione_cluster,
        value: r.codice_sigla
      });
    }));
    this.campaignService.getChannels().subscribe(res => {
      res.map(r => {
        this.channelsOptions.push({
          label: r.name,
          value: r.name
        })
      });
    });
  }

  /**
   * Svuota dati per le select e i radio nel form di modifica del coupon
  */
  emptyCouponEditingData() {
    this.discountTypes = [];
    this.categories = [];
    this.segmentOptions = [];
    this.channelsOptions = [];
  }

  /**
   * Permette all'utente di modificare i dati del singolo coupon
  */
  editRow(row, typeCode) {
    this.emptyCouponEditingData();
    this.callCouponEditingData(typeCode);
    this.editingMode = true;
    row.isEditable = true;
  }

  /**
   * Aggiorna i dati del coupon dopo modifica da parte dell'utente
  */
  saveRow(row) {
    this.savedCategories.forEach(sc => {
      if (sc.categoria_offerta === row.categoria) {
        row.codice_categoria = sc.codice_categoria;
      }
    });

    this.channels.forEach(channel => {
      if (channel.name === row.canale) {
        row.codice_canale = channel.value;
      }
    })

    let params = {
      id_coupon: row.id_coupon,
      id_coupon_breve: row.id_coupon_breve,
      codice_canale: row.codice_canale,
      codice_categoria: row.codice_categoria,
      sigle_cluster_modello_1 : row.clienti ? row.clienti.join("-") : null,
      descrizione_metodo: row.tipo_sconto,
      num_offerta: row.sconto ? parseFloat(row.sconto) : null,
      num_soglia: row.soglia ? parseFloat(row.soglia) : null,
      data_inizio_redemption: row.data_inizio_validita ? row.data_inizio_validita.substring(6, 10) + '-' + row.data_inizio_validita.substring(3, 5) + '-' + row.data_inizio_validita.substring(0, 2) : null,
      data_fine_redemption: row.data_fine_validita ? row.data_fine_validita.substring(6, 10) + '-' + row.data_fine_validita.substring(3, 5) + '-' + row.data_fine_validita.substring(0, 2) : null,
      textline5_testata : row.descrizione_breve ? row.descrizione_breve : null,
      textline6_testo_coup : row.descrizione_completa ? row.descrizione_completa : null,
      data_inizio_emissione : row.data_inizio_emissione ? row.data_inizio_emissione.substring(6, 10) + '-' + row.data_inizio_emissione.substring(3, 5) + '-' + row.data_inizio_emissione.substring(0, 2) : null,
      data_fine_emissione : row.data_fine_emissione ? row.data_fine_emissione.substring(6, 10) + '-' + row.data_fine_emissione.substring(3, 5) + '-' + row.data_fine_emissione.substring(0, 2) : null,
      codice_template: row.codice_template ? row.codice_template : null,
      bmp: row.codice_bmp ? row.codice_bmp : null,
      codice_layout: row.codice_layout ? row.codice_layout : null
    };

    this.campaignService.updateCoupon(params).subscribe(
      () => console.log('AGGIORNATO COUPON CON ID',row.id_coupon),
      error => console.error('ERROR',error),
      () => this.getCouponData()
    );

    this.emptyCouponEditingData();
    row.isEditable = false;
    this.editingMode = false;
  }

  /**
  * Elimina coupon
  */
  deleteRow(row) {
    // Elimina coupon da DB
    this.campaignService.deleteCoupon(row.id_coupon).subscribe(
      () => console.log('ELIMINATO COUPON CON ID',row.id_coupon),
      error => console.error('ERROR',error),
      () => this.getCouponData()
    );
  }

  /**
   * Aggiunge coupon
  */
  addRow(couponList, typeCode, i) {
    this.campaignService.addCoupon(this.campaignName, typeCode, {}).subscribe(
      res => console.log('ADD COUPON',res),
      error => console.error('ERROR',error),
      () => {
        this.campaignService.getCouponList(this.campaignName, typeCode).subscribe(
          res => {
            couponList = [];
            this.manageCouponData(res, couponList);
            this.goToTableLastPage(i, couponList);
          },
          error => console.error('ERROR', error)
        );
      }
    );
  }

  ngOnDestroy() {
    /* Invia nuovamente le categorie coupon selezionate e i coupon prodotto allo step precedente */
    if (this.savedCategories && this.savedCategories.length > 0) {
      this.returnedSavedCategories.emit([this.savedCategories, "step5"]);
    }
    this.returnedSavedProductCouponsF.emit(this.savedProductCouponsF);
    this.returnedSavedProductCouponsNF.emit(this.savedProductCouponsNF);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-5/campaign-step-5.component.ts